import * as Dialog from "@radix-ui/react-dialog";
import { useState } from "react";
import { useLanguageContext } from "../context/languageContext";
import { useCookies } from "../hooks/useCookies";
import { useTrackingScripts } from "../hooks/useTrackingScripts";
import { languageEN } from "../languageEN";
import { languagePL } from "../languagePL";

interface Props {
  example: boolean;
  setExample: React.Dispatch<React.SetStateAction<boolean>>;
}
export const CookiesModal = ({ example, setExample }: Props) => {
  const [customizeCookies, setCustomizeCookies] = useState(false);
  const [cookies, setCookie] = useCookies();
  const { language, setLanguage } = useLanguageContext();
  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 30);

  const [cookiePerformanceState, setCookiePerformanceState] = useState(true);
  const [cookieAdvertisingState, setCookieAdvertisingState] = useState(true);
  const [cookieMandatoryState, setCookieMandatoryState] = useState(true);

  useTrackingScripts({
    advertising: cookies.advertisingCookies === "true",
    performance: cookies.performanceCookies === "true",
  });

  const changeCookieValue = () => {
    setCustomizeCookies(false);
    setCookie("controlCookie", false, {
      path: "/",
      expires: currentDate,
    });

    if (cookieMandatoryState) {
      setCookie("mandatoryCookies", true, {
        path: "/",
        expires: currentDate,
      });
    } else {
      setCookie("mandatoryCookies", false, {
        path: "/",
        expires: currentDate,
      });
    }

    if (cookieAdvertisingState) {
      setCookie("advertisingCookies", true, {
        path: "/",
        expires: currentDate,
      });
      setExample(true);
    } else {
      setExample(false);
      setCookie("advertisingCookies", false, {
        path: "/",
        expires: currentDate,
      });
    }

    if (cookiePerformanceState) {
      setCookie("performanceCookies", true, {
        path: "/",
        expires: currentDate,
      });
      setExample(true);
    } else {
      setExample(false);
      setCookie("performanceCookies", false, {
        path: "/",
        expires: currentDate,
      });
    }

    window.location.reload();
  };

  const acceptAllCookies = () => {
    setExample(true);
    setCookie("performanceCookies", true, {
      path: "/",
      expires: currentDate,
    });
    setCookie("advertisingCookies", true, {
      path: "/",
      expires: currentDate,
    });
    setCookie("mandatoryCookies", true, {
      path: "/",
      expires: currentDate,
    });
    setCookie("controlCookie", false, {
      path: "/",
      expires: currentDate,
    });

    window.location.reload();
  };

  return (
    <Dialog.Root open={cookies.controlCookie === "true"}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <div className="info_modal ">
          <Dialog.Content className="modal-content ">
            <Dialog.Title asChild className="modal-header">
              <div>
                <p className="cookieModalHeader">
                  {language === "PL"
                    ? languagePL.cookieModalTitle
                    : languageEN.cookieModalTitle}
                </p>
              </div>
            </Dialog.Title>
            <Dialog.Description asChild className="modal-body container ">
              <div>
                <div className="cookie-contentSubHeading">
                  {language === "PL"
                    ? "Oprócz plików cookie, które są niezbędne do działania tej strony internetowej, używamy następujących rodzajów plików  cookie, aby poprawić komfort korzystania z witryny i naszych usług: Funkcjonalne pliki cookie, aby poprawić komfort korzystania z witryny (np. zapamiętać ustawienia), Wydajnościowe pliki cookie, aby zmierzyć wydajność witryny i poprawić komfort korzystania z niej, Reklamowe/targetujące pliki cookie, które są ustawiane przez strony trzecie, z którymi realizujemy kampanie reklamowe i pozwalają nam dostarczać Ci reklamy odpowiednie dla Ciebie. Zapoznaj się z naszą"
                    : "In addition to the cookies that are necessary for the operation of this website, we use the following types of cookies to improve your experience on the website and our services: Functionality cookies, to improve your experience on the website (e.g. remembering your settings), Performance cookies, to measure site performance and improve your user experience, advertising/targeting cookies, which are set by third parties with whom we run advertising campaigns and allow us to deliver advertisements relevant to you. Please see our"}
                  <a
                    href="https://www.ey.com/pl_pl/cookie-policy"
                    target="_blank"
                  >
                    {language === "PL" ? " polityką cookies" : " cookie policy"}
                  </a>
                  {language === "PL"
                    ? ", aby uzyskać więcej informacji."
                    : " for more information"}
                </div>
                {!customizeCookies ? (
                  <div className="cookies-buttonContainer">
                    <button
                      className="cookies-button"
                      onClick={() => acceptAllCookies()}
                    >
                      {language === "PL"
                        ? languagePL.cookieButtonAccept
                        : languageEN.cookieButtonAccept}
                    </button>
                    <button
                      className="cookies-button"
                      onClick={() => setCustomizeCookies(!customizeCookies)}
                    >
                      {language === "PL"
                        ? languagePL.cookieButtonOptions
                        : languageEN.cookieButtonOptions}
                    </button>
                  </div>
                ) : (
                  <div className="cookies-radioButtonList">
                    <div className="cookie-checkboxContainer">
                      <label className="cookie-checkboxContent">
                        <div className="cookie-checkbox">
                          {" "}
                          <input
                            type="checkbox"
                            onChange={() =>
                              setCookieMandatoryState(!cookieMandatoryState)
                            }
                            checked={cookieMandatoryState}
                          />
                        </div>
                        <div>
                          <p className="cookie-contentHeading">
                            {language === "PL"
                              ? languagePL.cookieCheckboxTitle1
                              : languageEN.cookieCheckboxTitle1}
                          </p>
                          <p className="cookie-contentSubHeading">
                            {language === "PL"
                              ? languagePL.cookieCheckboxDesc1
                              : languageEN.cookieCheckboxDesc1}
                          </p>
                        </div>
                      </label>
                    </div>
                    <div className="cookie-checkboxContainer">
                      <label className="cookie-checkboxContent">
                        <div className="cookie-checkbox">
                          {" "}
                          <input
                            type="checkbox"
                            checked={cookiePerformanceState}
                            onChange={() =>
                              setCookiePerformanceState(!cookiePerformanceState)
                            }
                          />
                        </div>
                        <div>
                          <p className="cookie-contentHeading">
                            {language === "PL"
                              ? languagePL.cookieCheckboxTitle2
                              : languageEN.cookieCheckboxTitle2}
                          </p>
                          <p className="cookie-contentSubHeading">
                            {language === "PL"
                              ? languagePL.cookieCheckboxDesc2
                              : languageEN.cookieCheckboxDesc2}
                          </p>
                        </div>
                      </label>
                    </div>
                    <div className="cookie-checkboxContainer">
                      <label className="cookie-checkboxContent">
                        <div className="cookie-checkbox">
                          {" "}
                          <input
                            type="checkbox"
                            checked={cookieAdvertisingState}
                            onChange={() =>
                              setCookieAdvertisingState(!cookieAdvertisingState)
                            }
                          />
                        </div>
                        <div>
                          <p className="cookie-contentHeading">
                            {language === "PL"
                              ? languagePL.cookieCheckboxTitle3
                              : languageEN.cookieCheckboxTitle3}
                          </p>
                          <p className="cookie-contentSubHeading">
                            {language === "PL"
                              ? languagePL.cookieCheckboxDesc3
                              : languageEN.cookieCheckboxDesc3}
                          </p>
                        </div>
                      </label>
                    </div>
                    <div className="cookies-buttonContainer">
                      <button
                        className="button_next"
                        onClick={() => changeCookieValue()}
                      >
                        {language === "PL"
                          ? languagePL.cookieOptionsAccept
                          : languageEN.cookieOptionsAccept}
                      </button>
                    </div>
                    <div className="cookie-table-wrapper">
                      <p className="cookie-contentHeading">
                        {" "}
                        {language === "PL"
                          ? languagePL.cookieTableHeader
                          : languageEN.cookieTableHeader}
                      </p>
                      <table className="cookies-table">
                        <tr>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading
                              : languageEN.cookieHeading}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading2
                              : languageEN.cookieHeading2}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading3
                              : languageEN.cookieHeading3}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading4
                              : languageEN.cookieHeading4}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading5
                              : languageEN.cookieHeading5}
                          </th>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            {language === "PL"
                              ? languagePL.cookieTableContext
                              : languageEN.cookieTableContext}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext2
                              : languageEN.cookieTableContext2}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext3
                              : languageEN.cookieTableContext3}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext4
                              : languageEN.cookieTableContext4}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext5
                              : languageEN.cookieTableContext5}
                          </td>
                        </tr>
                      </table>
                      <p className="cookie-contentHeading">
                        {language === "PL"
                          ? languagePL.cookieTableHeader2
                          : languageEN.cookieTableHeader2}
                      </p>
                      <table className="cookies-table">
                        <tr>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading6
                              : languageEN.cookieHeading6}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading7
                              : languageEN.cookieHeading7}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading8
                              : languageEN.cookieHeading8}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading9
                              : languageEN.cookieHeading9}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading10
                              : languageEN.cookieHeading10}
                          </th>
                        </tr>
                        <tr>
                          <td>{"_pk_id.<appID>.<domainHash>"}</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext7_1
                              : languageEN.cookieTableContext7_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext8_1
                              : languageEN.cookieTabContext8_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext9_1
                              : languageEN.cookieTabContext9_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext10_1
                              : languageEN.cookieTabContext10_1}
                          </td>
                        </tr>
                        <tr>
                          <td>{"_pk_ses.<appID>.<domainHash>"}</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext7_2
                              : languageEN.cookieTableContext7_2}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext8_2
                              : languageEN.cookieTabContext8_2}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext9_2
                              : languageEN.cookieTabContext9_2}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext10_2
                              : languageEN.cookieTabContext10_2}
                          </td>
                        </tr>
                        <tr>
                          <td>stg_last_interaction</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext7_3
                              : languageEN.cookieTableContext7_3}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext8_3
                              : languageEN.cookieTabContext8_3}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext9_3
                              : languageEN.cookieTabContext9_3}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext10_3
                              : languageEN.cookieTabContext10_3}
                          </td>
                        </tr>
                        <tr>
                          <td>stg_returning_visitor</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext7_4
                              : languageEN.cookieTableContext7_4}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext8_4
                              : languageEN.cookieTabContext8_4}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext9_4
                              : languageEN.cookieTabContext9_4}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext10_4
                              : languageEN.cookieTabContext10_4}
                            i
                          </td>
                        </tr>
                        <tr>
                          <td>stg_traffic_source_priority</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTableContext7_5
                              : languageEN.cookieTableContext7_5}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext8_5
                              : languageEN.cookieTabContext8_5}
                          </td>
                          <td>
                            {" "}
                            {language === "PL"
                              ? languagePL.cookieTabContext9_5
                              : languageEN.cookieTabContext9_5}
                          </td>
                          <td>
                            {" "}
                            {language === "PL"
                              ? languagePL.cookieTabContext10_5
                              : languageEN.cookieTabContext10_5}
                          </td>
                        </tr>
                      </table>
                      <p className="cookie-contentHeading">
                        {" "}
                        {language === "PL"
                          ? languagePL.cookieTableHeader3
                          : languageEN.cookieTableHeader3}
                      </p>
                      <table className="cookies-table">
                        <tr>
                          <th>
                            {" "}
                            {language === "PL"
                              ? languagePL.cookieHeading11
                              : languageEN.cookieHeading11}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading12
                              : languageEN.cookieHeading12}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading13
                              : languageEN.cookieHeading13}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading14
                              : languageEN.cookieHeading14}
                          </th>
                          <th>
                            {language === "PL"
                              ? languagePL.cookieHeading15
                              : languageEN.cookieHeading15}
                          </th>
                        </tr>
                        <tr>
                          <td>{"ln_or"}</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext12_1
                              : languageEN.cookieTabContext12_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext13_1
                              : languageEN.cookieTabContext13_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext14_1
                              : languageEN.cookieTabContext14_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext15_1
                              : languageEN.cookieTabContext15_1}
                          </td>
                        </tr>
                        <tr>
                          <td>{"_gcl_au"}</td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext12_2
                              : languageEN.cookieTabContext12_2}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext13_2
                              : languageEN.cookieTabContext13_2}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext14_1
                              : languageEN.cookieTabContext14_1}
                          </td>
                          <td>
                            {language === "PL"
                              ? languagePL.cookieTabContext15_1
                              : languageEN.cookieTabContext15_1}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </Dialog.Description>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
